import { useContext } from 'react'
import { InventoryContext, type IInventoryContext } from './InventoryContext'

const useInventory = (): IInventoryContext => {
  return useContext(InventoryContext)
}

export default useInventory
